import React from "react";
import "./Orders.css";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import ChantPopConfirm from "../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { DownloadIcon } from "../../../../utils/icons.jsx";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader/ScreenHeader.jsx";
import IconContainer from "../../../../CommonComponents/IconContainer";

const OrderActions = ({
  tableData,
  handleUpdateOrder,
  handleDownloadCsv,
  downloading,
  showUpdateOrders,
}) => {
  return (
    <div>
      <ScreenHeader
        title="Orders"
        elementCount={tableData?.length}
        actions={
          <div className="orders-action-buttons">
            <ChantPopConfirm
              title="Download all orders list?"
              onConfirm={() => handleDownloadCsv(tableData)}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
              trigger="click"
            >
              <IconContainer loading={downloading} icon={DownloadIcon} />
            </ChantPopConfirm>

            {showUpdateOrders && (
              <ChantButton onClick={handleUpdateOrder}>
                Update Orders
              </ChantButton>
            )}
          </div>
        }
      />
    </div>
  );
};

export default OrderActions;
